export default function* watchTicketingSystem() {}
